//This is a place to add important colors and import them as needed to each file

const Colors = {
  primary: '#478ACA',
  secondary: '#FFFDED',
  yellow: '#FFD54C',
  white: '#FFF',
  lighter: '#F3F3F3',
  light: '#7a7a7a',
  dark: '#687888',
  black: '#000',
  orange: '#ff9829',
  bgMask: 'rgba(0,0,0,0.5)',
  green: '#228B22',
  red: '#ff0000',
  lightBlue: 'rgba(71,138,202,.4',
  lightgrey: 'rgba(0, 0, 0, 0.2)',
  lessDark: '#333333',
  paleGrey: '#ecf3f9',
  lineColor: '#3f89c6',
  grey: '#e5e8eb',
};

export default Colors;
